<template>
  <div class="container">
    <v-Header></v-Header>
    <h4 class="title">
      <span>&nbsp;&nbsp;咨询详情</span>
    </h4>
    <div class="headContent">
      <el-row>
        <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="10">申请人工号：</el-col>
            <el-col :span="14">
              <el-input :value="dataCollect.agentCode" readonly></el-input>
              </el-col>
          </el-row>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="10">客户姓名：</el-col>
            <el-col :span="14">
              <el-input :value="dataCollect.customerName" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="8">证件类型：</el-col>
            <el-col :span="16">
              <el-input :value="dataCollect.idType" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="8">客户生日：</el-col>
            <el-col :span="12">
              <el-input :value="dataCollect.customerBirth" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="10">申请人姓名：</el-col>
            <el-col :span="14">
              <el-input :value="dataCollect.agentName" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="10">客户性别：</el-col>
            <el-col :span="14">
              <el-input :value="dataCollect.customerGender" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="8">证件号码：</el-col>
            <el-col :span="16">
              <el-input :value="dataCollect.idNo" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="8">修改状态：</el-col>
            <el-col :span="12">
              <el-input :value="dataCollect.modifyState" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="10">咨询类型：</el-col>
            <el-col :span="14">
              <el-input :value="dataCollect.consultType" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="5" :offset="1">
         <el-row>
            <el-col :span="10">咨询状态：</el-col>
            <el-col :span="14">
              <el-input :value="dataCollect.state" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="8">创建日期：</el-col>
            <el-col :span="16">
              <el-input :value="dataCollect.createDate" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <h4 class="contentTitle">
        <span>&nbsp;&nbsp;咨询内容</span>
      </h4>
    </div>
    <div class="tableBottom">
      <el-table
        :data="contentInfos"
        border
        style="width:99%;margin:20px auto 0;">
        <el-table-column
          align="center"
          prop="consultDate"
          label="咨询时间"
          width="165"
          >
        </el-table-column>
        <el-table-column
          align="center"
          prop="consultContent"
          label="咨询内容"
          width="165"
          >
        </el-table-column>
        <el-table-column
          align="center"
          prop="replyContent"
          label="回复内容"
          width="165">
        </el-table-column>
        <el-table-column
          align="center"
          label="咨询图片"
          width="120">
          <template slot-scope="scope">
          <el-button
            type="primary"
            v-if="imgsCollect[scope.$index].length>0"
            size="mini"
            @click="handleImg(scope.row)">查看图片</el-button>
        </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="replyDate"
          label="回复时间"
          width="165"
          >
        </el-table-column>
        <el-table-column
          align="center"
          prop="newestReplyContent"
          label="修改后回复内容"
          width="165">
          <template slot-scope="scope">
            <span>{{scope.row.newestReplyContent}}</span>
          <el-button
            type="primary"
            size="mini"
            @click="updateReply(scope.row)">点击修改</el-button>
        </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="newestReplyName"
          label="修改人姓名"
          width="165"
          >
        </el-table-column>
        <el-table-column
          align="center"
          prop="newestReplyCode"
          label="修改人工号"
          width="165"
          >
        </el-table-column>
        <el-table-column
          align="center"
          prop="newestReplyDate"
          label="最新修改时间"
          width="165"
          >
        </el-table-column>
      </el-table>
      <div class="fixBtn">
        <el-button type="primary" @click="goback">返回</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="dialogTableVisible" title="修改回复内容">
      <el-input resize="none"  type="textarea" :rows="2" placeholder="添加回复内容" v-model="replyContent"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clickCancel">取 消</el-button>
        <el-button type="primary" @click="submit">提 交</el-button>
      </div>
    </el-dialog>
    <!-- 图片展示 -->
    <div class="dialogWh">
      <el-dialog :visible.sync="showImg" v-if="show">
        <div v-for="item in imgs" :key="item" class="dialogImg">
          <img v-image-preview :src="item"/>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import vHeader from '@/layout/Header.vue'
import api from '@/modules/api.js';
import url from '@/modules/url.js';
export default {
  name:'OperationDetail',
  data(){
    return {
      dataCollect:{},
      contentInfos:[],
      dialogTableVisible:false,
      showImg:false,
      imgs:[], //照片容器
      show:false,
      replyContent:'',
      imgsCollect:[]
    }
  },
  methods:{
    getConsultDetailPC(){
      if(sessionStorage.getItem('consultNo')){
        this.consultNo = JSON.parse(decodeURIComponent(sessionStorage.getItem('consultNo')))
      }
      let param = {
        consultNo:this.consultNo
      }
      api.post(url.getConsultDetailPC, param, res=> {
        if(res.result.isSuccess){
          this.dataCollect.consultType = res.data.consultType
          this.dataCollect.idType = res.data.idType
          this.dataCollect.agentCode = res.data.agentCode
          this.dataCollect.customerGender = res.data.customerGender
          this.dataCollect.agentName = res.data.agentName
          this.dataCollect.consultNo = res.data.consultNo
          this.dataCollect.idNo = res.data.idNo
          this.dataCollect.customerName = res.data.customerName
          this.dataCollect.createDate = res.data.createDate
          this.contentInfos = res.data.contentInfos
          this.dataCollect.modifyState = res.data.modifyState
          this.dataCollect.state = res.data.state
          this.dataCollect.customerBirth = res.data.customerBirth
          this.contentInfos.forEach(item=>{
            this.imgsCollect.push(item.images)
          })
        }
      });
    },
    handleImg(val){
      // console.log(val,'ddd')
      this.showImg = true
      this.show = true
      this.imgs = val.images
    },
    updateReply(row){
      this.dialogTableVisible = true
      this.contentId = row.contentId
    },
    submit(){
      let params ={
        contentId:this.contentId,
        replyContent:this.replyContent,
      }
      if(!this.replyContent){
        this.$message.error('请输入回复内容')
        return false
      }
      api.post(url.modifyReply, params, res=> {
        if(res.result.isSuccess){
          this.getConsultDetailPC()
          this.dialogTableVisible = false
          this.replyContent = ''
        }else{
          
        }
      });
    },
    clickCancel(){
      this.dialogTableVisible = false
      this.replyContent = ''
    },
    goback(){
      let getList = this.$route.params.getNochange
      let req = this.$route.params.getList
      let customerName = this.$route.params.customerName
      let applyName = this.$route.params.applyName
      let applyCode = this.$route.params.applyCode
      let idNo = this.$route.params.idNo
      let dateStart = this.$route.params.dateStart
      // console.log(dateStart,'dateStart')
      this.$router.push({
        name:'OperationList',
        params:{
          req,
          customerName,
          applyName,
          applyCode,
          getList,
          dateStart,
          idNo,
        }
      })
    }
  },
  mounted(){
    this.getConsultDetailPC()
  },
  components:{
    vHeader
  }
}
</script>
<style scoped>
.title {
  background: #e0e0e0;
  height: 50px;
  line-height: 50px;
  margin: 0;
}
.headContent{
  padding: 20px 0 20px 0;
  line-height: 55px;
  background: #fff;
}
.headContent >>> .el-row{
  height: 55px;
}
.img >>> .el-row{
  line-height: 55px;
}
.img >>> .el-col-18{
  margin-top:15px;
}
.content{
  background: #fff;
}
.contentTitle{
  background: #e0e0e0;
  height: 50px;
  line-height: 50px;
  margin: 0;
}
.contentTip{
  padding: 10px 0 10px 100px;
}
.contentTip p{
  font-size: 13px;
}
.contentTip p>span{
  display: inline;
  margin-right: 10px;
}
.container {
  background: #fff;
  height: 100vh;
}
.container >>> .el-dialog{
  width: 400px;
  height: 300px;
}
.container >>> .el-textarea__inner{
  height: 150px;
}
.container >>> .el-dialog__footer{
  width: 100%;
  display: flex;
  justify-content:space-around;
}
.container >>>  .el-dialog__body{
  padding:10px 20px;
}
.tableBottom{
  background: #fff;
}
.dialogImg {
  display: inline-block;
}
.dialogImg img{
  margin-right: 10px;
  width: 100px;height: auto;
}
.dialogWh{
  background: #fff;
}
.dialogWh >>> .el-dialog {
  z-index:2000;
  width: 600px;min-height:400px;
  height:auto;
}
.fixBtn{
  position: fixed;
  bottom: 30px;
  right: 30px;
}
</style>
<style>
body /deep/ .vue-directive-image-previewer{
  z-index: 10000;
}
body /deep/ .vue-directive-image-previewer-body{
  z-index: 3000;
}
body /deep/ .vue-directive-image-previewer-body img{
  z-index: 3000;
}
</style>


// WEBPACK FOOTER //
// src/pages/client/operationDetail.vue